import { createSlice } from '@reduxjs/toolkit';
import { t } from 'i18next';
import { toast } from 'react-toastify';

const EmployeeRolesSlice = createSlice({
    name: 'employeeRoles',
    initialState: {
        roleListData: [],
        roleList: [],
        employeesWithRoleList: [],
        allEmployeesList: [],
        pageableEmployeesList: [],
        selectedEmployeesList: [],
        singleRoleObj: {},
        removeRoleToUser: {},
        updateRoleSuccess: {},
        creteRoleSuccess: {},
    },
    reducers: {
        EmployeesInCreate: (state, action) => {
            state.selectedEmployeesList = action.payload;
        },
        HandleEmployeesWithRole: (state, action) => {
            state.employeesWithRoleList = action.payload;
        },
    },
    extraReducers: {
        'employeeRoles/roleAvailableTasks/fulfilled': (state, action) => {
            const {
                data: { data },
                status,
            } = action.payload || {};
            if (status >= 200 && status < 300) {
                // Filter out objects with name containing "_Menu"
                const filteredMenu = data.filter((item) => item.name.substring(item.name.length - 5) !== '_MENU');
                state.roleListData = filteredMenu;
            } else if (status >= 400 && status < 500) {
                toast.error(t('something_went_wrong_2'));
            }
        },
        'employeeRoles/getEmployeeRoles/fulfilled': (state, action) => {
            const {
                data: { data },
                status,
            } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.roleList = data;
            } else if (status >= 400 && status < 500) {
                toast.error(t('something_went_wrong_2'));
            }
        },
        'employeeRoles/getEmployesWithRole/fulfilled': (state, action) => {
            const {
                data: { data },
                status,
            } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.employeesWithRoleList = data;
                state.selectedEmployeesList = data;
            } else if (status >= 400 && status < 500) {
                toast.error(t('something_went_wrong_2'));
            }
        },
        'employeeRoles/getAllEmployees/fulfilled': (state, action) => {
            const {
                data: { data },
                status,
            } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.allEmployeesList = data;
            } else if (status >= 400 && status < 500) {
                toast.error(t('something_went_wrong_2'));
            }
        },
        'employeeRoles/getAllroleEmployeesPageable/fulfilled': (state, action) => {
            const {
                data: { data },
                status,
            } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.pageableEmployeesList = data;
            } else if (status >= 400 && status < 500) {
                toast.error(t('something_went_wrong_2'));
            }
        },
        'employeeRoles/removeRoleToUserById/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.removeRoleToUser = data;
                 toast.success(t('has_been_deleted_successfully'));
            } else if (status >= 400 && status < 500) {
                toast.error(t('something_went_wrong_2'));
            }
        },
        'employeeRoles/creatRole/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.creteRoleSuccess = data;
                toast.success(t('has_been_created_successfully'));
            } else if (status >= 400 && status > 500) {
                toast(data.message);
            }
        },
        'employeeRoles/addPermissionTask/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                toast.success(t('has_been_added_successfully'));
            } else if (status >= 400 && status < 500) {
                toast.error(t('something_went_wrong_2'));
            }
        },
        'employeeRoles/updateRoleRestriction/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                toast.success(t('has_been_updated_successfully'));
            } else if (status >= 400 && status < 500) {
                toast.error(t('something_went_wrong_2'));
            }
        },
        'employeeRoles/GetSingleRole/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.singleRoleObj = data?.data;
            } else if (status >= 400 && status < 500) {
                toast.error(t('something_went_wrong_2'));
            }
        },
        'employeeRoles/UpdateRole/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.updateRoleSuccess = data;
                toast.success(t('has_been_updated_successfully'));
            }
        },
    },
});
export const { EmployeesInCreate, HandleEmployeesWithRole, HandleTaskList, HandleChoosedList } =
    EmployeeRolesSlice.actions;

export default EmployeeRolesSlice.reducer;
